export const SET_INIT = '@CONFIG/SET_INIT';
export const UPDATE_LIST_RELATION = '@CONFIG/UPDATE_LIST_RELATION';
export const UPDATE_FORM_RELATION = '@CONFIG/UPDATE_FORM_RELATION';
export const UPDATE_GLOBAL_PARAMS = '@CONFIG/UPDATE_GLOBAL_PARAMS';
export const SET_GPARAMS_READY = '@CONFIG/SET_GPARAMS_READY';
